import { auth } from './firebase';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

export const adminSignIn = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

export const adminSignOut = () => signOut(auth);

export const onAdminAuthStateChanged = (callback) =>
  onAuthStateChanged(auth, callback);